module.exports = __webpack_public_path__ + "static/RateYourMusic-54cc3c5b06bfae71e434838e701917c3.png";